/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyEngine_Models_Platform {
    AI = 'AI',
    IVR = 'IVR',
    MOBILE = 'Mobile',
    SMS = 'SMS',
    WEB = 'Web',
}
